import Modal from 'react-bootstrap/Modal';
import React, { useEffect } from 'react';
import { Form, Input } from 'antd';

const ShipmentCodeModal = ({ printLabel, inputRef, isVisible, setIsVisible, focusCode, setFocusCode, codeError, setCodeError }) => {
  const onFinish = (value) => {
    console.log(value, isVisible);
    closeModal();
    printLabel(isVisible.order, isVisible.key, value.trackingNumber);
  };
  const closeModal = () => {
    setIsVisible({
      open: false,
      order: null,
      key: null,
    });
  };

  useEffect(() => {
    // console.log('9470111899562082997366'.length); /// 22
    if (inputRef.current) {
      console.log(inputRef);
      inputRef.current.focus();
    }
  }, []);
  const onFinishFailed = () =>{}
  return (
    <div>
      <Modal show={isVisible.open} size='md' onHide={closeModal} centered>
        <Modal.Header closeButton={true} className='p-0'>
          <Modal.Title className='fw-bold px-3' style={{ display: 'block', padding: '8px', fontSize: '20px' }}>
            {/* Order Details */} Shipment Label
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: '0px 20px !important' }}>
          {/* input */}
          <Form className='row px-1 pb-1' onFinish={onFinish} onFinishFailed={onFinishFailed}>
            <div className='col-12 input-column'>
              <label>
                Tracking No.
                <span className='required-star'>*</span>
              </label>
              <Form.Item
                name='trackingNumber'
                colon={false}
                rules={[
                  {
                    required: true,
                    message: 'Tracking No.',
                  },
                ]}
              >
                <Input name='T' ref={focusCode === 'T' ? inputRef : null} placeholder='Tracking No.' maxLength={25} />
              </Form.Item>
            </div>
            {codeError && (
              <div className='col-12' style={{ marginTop: '-1.5rem', marginBottom: '0.5rem' }}>
                <span className='text-danger'>{codeError}</span>
              </div>
            )}
            <div className='col-12 text-end mb-2'>
              <button type='primary' class='btn btn-primary button' htmlType='submit'>
                Print Label
              </button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ShipmentCodeModal;
